// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"09f9b3f5","361":"ee7248d6","511":"2cd4e069","767":"3c00c15a"}[chunkId] + ".chunk.js";
};